import UserForm from "../UserForm";

const AddAdminForm = ({ onSubmit, isLoading, onCloseClicked }) => {
  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[600px]">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add Admin</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <UserForm isLoading={isLoading} onSubmit={onSubmit} />
    </div>
  )
}

export default AddAdminForm;
